import classNames from 'classnames'
import { useMemo } from 'react'

import { ErrorIcon, SuccessIcon } from '../toast-notification/icons'

export const validatePassword = (str: string) => {
    const errors = {
        lowercase: true,
        upperCase: true,
        numbers: true,
        characterRange: true,
    }
    // validate that str has at least one lowercase character
    if (/[a-z]/.test(str)) {
        errors.lowercase = false
    }
    // validate that str has at least one uppercase character
    if (/[A-Z]/.test(str)) {
        errors.upperCase = false
    }
    // validate that str has at least one number
    if (/[0-9]/.test(str)) {
        errors.numbers = false
    }

    // validate that str has between 10 and 20 characters
    if (str.length >= 10) {
        errors.characterRange = false
    }

    return errors
}

export function PasswordValidator({ str }: { str: string }) {
    const errors = useMemo(() => validatePassword(str), [str])

    const empty = useMemo(() => str.length === 0, [str])

    const passwordValidationStyles = classNames(
        'border rounded-md grid grid-rows-2 grid-cols-2 mt-4 p-3 gap-2',
        {
            'border-default filter grayscale': empty,
        },
        {
            'shadow-lg': !empty,
        },
        {
            'border-danger':
                !empty &&
                Object.keys(errors).some(
                    (item: string) =>
                        !!errors[
                            item as
                                | 'upperCase'
                                | 'lowercase'
                                | 'characterRange'
                                | 'numbers'
                        ],
                ),
        },
        {
            'border-success':
                !empty &&
                !Object.keys(errors).some(
                    (item: string) =>
                        !!errors[
                            item as
                                | 'upperCase'
                                | 'lowercase'
                                | 'characterRange'
                                | 'numbers'
                        ],
                ),
        },
    )

    const validationItemStyles = classNames(
        'col-span-1 row-span-1 flex flex-row gap-2 filter',
    )

    const validatorLabelStyles = classNames(
        'text-black text-md items-center m-0',
    )

    return (
        <div className={passwordValidationStyles}>
            <div className={validationItemStyles}>
                {errors.lowercase ? <ErrorIcon /> : <SuccessIcon />}
                <p className={validatorLabelStyles}>lower-case</p>
            </div>
            <div className={validationItemStyles}>
                {errors.numbers ? <ErrorIcon /> : <SuccessIcon />}

                <p className={validatorLabelStyles}>numbers</p>
            </div>
            <div className={validationItemStyles}>
                {errors.upperCase ? <ErrorIcon /> : <SuccessIcon />}

                <p className={validatorLabelStyles}>upper-case</p>
            </div>
            <div className={validationItemStyles}>
                {errors.characterRange ? <ErrorIcon /> : <SuccessIcon />}

                <p className={validatorLabelStyles}>more than 10 characters</p>
            </div>
        </div>
    )
}
